import {ServiceBase} from '../ServiceBase';
import {IServiceFactoryExtended} from '../service-factory-extended.interface';
import {ICrossBrandsService, ICrossSpecificNavigationInfo} from "./cross-brands.service.interface";
import _ from "../../../sdk/src/utils/underscore";
import {LocalStorageKeys} from "../storage/local-storage-keys";

export class CrossBrandsService extends ServiceBase implements ICrossBrandsService {
  constructor(services: IServiceFactoryExtended) {
    super(services);

    const specificNavigationInfo = this._extractSpecificNavigationFromCurrentUrl();
    if(specificNavigationInfo) {
      this.services.localStorage.setJson(LocalStorageKeys.crossBrandSpecificNavigationInfo, specificNavigationInfo);
    } else {
      this.services.localStorage.removeItem(LocalStorageKeys.crossBrandSpecificNavigationInfo);
    }

    this.services.sdk.events.onTokenLifetimeExpired(this._onTokenLifetimeExpired.bind(this));
  }

  private _onTokenLifetimeExpired(): void {
    const crossBrandNavigationInfo = this.crossBackSpecificNavigation;
    if(crossBrandNavigationInfo && crossBrandNavigationInfo.callbackMethod === 'redirect') {
      this.services.location.redirect(crossBrandNavigationInfo.callbackUrl + '?ActionId=201');
    }
  }

  get crossBackSpecificNavigation(): ICrossSpecificNavigationInfo | null {
    return this.services.localStorage.getJson<ICrossSpecificNavigationInfo>(LocalStorageKeys.crossBrandSpecificNavigationInfo);
  }

  get isCrossFromOtherBrand(): boolean {
    return Boolean(this.crossBackSpecificNavigation);
  }

  get isCrossFromPoker(): boolean {
    return this.isCrossFromOtherBrand && this.services.segmentation.isCIP;
  }

  get isCrossFromSport(): boolean {
    return this.isCrossFromOtherBrand && this.services.segmentation.isCIS;
  }

  private _extractSpecificNavigationFromCurrentUrl(): ICrossSpecificNavigationInfo | null {
    const specificNavigationParamValue = this.services.location.currentUri.queryParams.getParamValue('specificNavigation');
    if(!specificNavigationParamValue) {
      return null;
    }

    if(specificNavigationParamValue.startsWith('http')) {
      return {
        callbackUrl: specificNavigationParamValue
      };
    }

    const specificNavigationXml = _.parseXml(specificNavigationParamValue);
    if(!specificNavigationXml) {
      return null;
    }

    let callbackUrl: string;
    let callbackMethod: string;
    let xmlElement = specificNavigationXml.getElementsByTagName("CallBackURL");
    if (xmlElement && xmlElement.length > 0) {
      callbackUrl = xmlElement.item(0).textContent;
    }

    xmlElement = specificNavigationXml.getElementsByTagName("callbackMethod");
    if (xmlElement && xmlElement.length > 0) {
      callbackMethod = xmlElement.item(0).textContent;
    }

    if(callbackUrl) {
      return {
        callbackUrl: callbackUrl,
        callbackMethod: callbackMethod
      };
    }
  }
}
